import { Database } from '@my/supabase/types'
import { useSupabaseClient } from 'app/providers/supabase/SessionContext'
export const useSupabase = () => {
  return useSupabaseClient<Database>()
}
